/**
 * Device and browser detection utilities.
 * Used for showing platform-specific instructions (camera permissions, GPS, etc.)
 */

export type DeviceType = 'ios-safari' | 'ios-chrome' | 'android-chrome' | 'android-other' | 'unknown';

/**
 * Detects the current device type based on user agent.
 */
export function detectDeviceType(): DeviceType {
  const ua = navigator.userAgent.toLowerCase();

  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  const isSafari = /safari/.test(ua) && !/chrome|crios|fxios/.test(ua);
  const isChrome = /chrome|crios/.test(ua) && !/edge|edgios/.test(ua);

  if (isIOS) {
    if (isSafari) return 'ios-safari';
    if (isChrome) return 'ios-chrome';
    return 'ios-safari'; // Default to Safari instructions for other iOS browsers
  }

  if (isAndroid) {
    if (isChrome) return 'android-chrome';
    return 'android-other';
  }

  return 'unknown';
}
